import { render, staticRenderFns } from "./DbdDocument.vue?vue&type=template&id=1b3016a8&"
import script from "./DbdDocument.vue?vue&type=script&lang=js&"
export * from "./DbdDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports